module.exports = __webpack_public_path__ + "static/media/major.35d77fce.jpg";